export default {
  init() {
      $(document).on('click', '.zd-cart-plus, .zd-cart-minus', e => {
        this.updateQuantity(e.target)
      })
  },
  updateQuantity(target) {
    const $input = $(target).siblings('.quantity:first').find('input.qty')
    if (!$input.length) return

    const val = parseInt($input.val())
    const step = parseInt($input.attr('step') || 1)
    const amount = $(target).is('.zd-cart-plus') ? (val + step) : (val - step)

    if (val > 0) $input.val(amount)

    setTimeout(() => {
      $('[name="update_cart"]').removeAttr('disabled').trigger('click');
    }, 0)
  },
};
